"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComposeDialog = ComposeDialog;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Stack = _interopRequireDefault(require("@mui/material/Stack"));
var _styles = require("@mui/material/styles");
var _Profile = require("./components/Profile");
var _InputField = require("./components/InputField");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Item = (0, _styles.styled)(_Box.default)(function (_ref) {
  var theme = _ref.theme;
  return _objectSpread(_objectSpread({}, theme.typography.body1), {}, {
    alignSelf: "flex-start",
    textAlign: "center",
    lineHeight: ".5rem",
    fontSize: "1rem"
  });
});
function ComposeDialog(_ref2) {
  var profile = _ref2.profile;
  return /*#__PURE__*/_react.default.createElement(_Stack.default, {
    direction: "row",
    spacing: 2,
    alignItems: "center",
    justifyContent: "flex-start",
    sx: {
      flexGrow: 1
    }
  }, /*#__PURE__*/_react.default.createElement(Item, {
    sx: {
      display: {
        xs: "none",
        sm: "block"
      },
      mt: "1rem"
    }
  }, /*#__PURE__*/_react.default.createElement(_Profile.Profile, {
    profile: profile
  })), /*#__PURE__*/_react.default.createElement(Item, {
    sx: {
      marginLeft: "10rem"
    }
  }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
    direction: "column",
    spacing: 2,
    justifyContent: "flex-start",
    alignItems: "center"
  }), /*#__PURE__*/_react.default.createElement(_Box.default, null, /*#__PURE__*/_react.default.createElement(_InputField.InputField, {
    label: "Subject",
    name: "subject"
  }), /*#__PURE__*/_react.default.createElement(_InputField.InputField, {
    multiline: true,
    minRows: "8",
    label: "Message",
    name: "body"
  }))));
}
ComposeDialog.propTypes = {
  profile: _propTypes.default.object
};